import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-dash-card-details',
  templateUrl: './dash-card-details.component.html',
  styleUrls: ['./dash-card-details.component.css']
})
export class DashCardDetailsComponent implements OnInit {

  constructor() { }

  @Input() dashData;

  ngOnInit() {
  }

}
